import styled from 'styled-components';

export const SidebarContainer = styled.div`
  width: 100%;
  overflow: auto;
  display: flex;
  flex-direction: column;
  padding: var(--spacing-l);
  margin-right: 36px;

  > div:last-of-type {
    overflow: initial;
  }

  [data-remove-after-refactoring='chart-configuration-section'] {
    padding-inline: 0;

    > h4 {
      font-weight: 700;
      font-size: 16px;
    }
  }
`;
